import ListModule from "../../../../layout/components/CRUD/List/List";

function List() {
  return (
    <ListModule module="brands" modulePath="/brands" primary_id="brand_id" />
  );
}

export default List;
